import { motion } from 'framer-motion'
import { Helmet } from 'react-helmet-async'
import Team from '../components/Team'

export default function TeamPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <Helmet>
        <title>Team | Ionic Errrrs Code</title>
        <meta name="description" content="Meet the talented developers and designers behind Ionic Errrrs Code — a skilled team passionate about building great software." />
        <link rel="canonical" href="https://ionicerrrrscode.com/team" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Ionic Errrrs Code" />
        <meta property="og:title" content="Team | Ionic Errrrs Code" />
        <meta property="og:description" content="Meet the talented developers and designers behind Ionic Errrrs Code — a skilled team passionate about building great software." />
        <meta property="og:url" content="https://ionicerrrrscode.com/team" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Team | Ionic Errrrs Code" />
        <meta name="twitter:description" content="Meet the talented developers and designers behind Ionic Errrrs Code — a skilled team passionate about building great software." />
      </Helmet>
      <Team />
    </motion.div>
  )
}
